import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_AGENCIES,
	SET_CREDENTIALS,
	SET_CREDENTIAL_TYPES,
	SET_CONTACT,
	SET_CONTACT_TAGS,
	SET_CONTACT_LIST,
	SET_CONTACT_TYPES,
	SET_MANAGEMENT,
	SET_TABLE_STATE,
	SET_VENDORS
} = actionDeclarer;

const contactsReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_AGENCIES:
			return {
				...state,
				agencyOrganizations: payload
			};
		case SET_CONTACT:
			return {
				...state,
				contact: payload
			};
		case SET_CONTACT_TAGS:
			return {
				...state,
				contactTags: payload
			};
		case SET_CONTACT_LIST:
			return {
				...state,
				contactList: payload
			};
		case SET_CONTACT_TYPES:
			return {
				...state,
				contactTypes: payload
			};
		case SET_CREDENTIALS:
			return {
				...state,
				contact: {
					...state.contact,
					credentials: payload
				}
			};
		case SET_CREDENTIAL_TYPES:
			return {
				...state,
				credentialTypes: payload
			};
		case SET_MANAGEMENT:
			return {
				...state,
				managementOrganizations: payload
			};
		case SET_TABLE_STATE:
			return {
				...state,
				tableState: payload( state.tableState )
			};
		case SET_VENDORS:
			return {
				...state,
				vendorOrganizations: payload
			};
		default:
			return state;
	}
};

export default contactsReducer;
